import React, { useEffect, useState } from "react";
import { StyleSheet, css } from "aphrodite";
import ProductInfo from "./productInfo";
import ProductItem from "./productItem";
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import {readProductsFromDB,deleteProductFromDB} from "../../../services/firebase"
import { gapi } from "gapi-script";

export default function InternalUserProductCreation(){

    useEffect(()=>{
        function start(){
            gapi.client.init({
                clientId: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID,
                scope:""
            })
        }
        gapi.load('client:auth2',start)
    },[])
    const [productsList, setProductsList] = useState("")
    const getAllProducts = ()=>{
        readProductsFromDB(setProductsList)
        
    }
    const [title,setTitle] = useState('Products')
    const [productDisplayInfo, setProductDisplayInfo] = useState(
        <ProductInfo
            mainImage={''}
            title={''}
            productTpe={''}
            description={''}
            secondImage={''}
            firstMiniTitle={''}
            fisrtMiniDescription={''}
            thirdImage={''}
            secondMiniDescription={''}
            secondMiniTitle={''}
            specs={''}
            otherImages={''}
            url={''}
            uid={false}
        />
    )
    
    const goodEmails = [
        process.env.REACT_APP_GOOGLE_AUTH_GOOD_EMAIL_1,
        process.env.REACT_APP_GOOGLE_AUTH_GOOD_EMAIL_2,
        process.env.REACT_APP_GOOGLE_AUTH_GOOD_EMAIL_3
    ]

    const [authSuccesfull, setAuthSuccesfull] = useState(false)
    const [pageState, setPageState] = useState(true)

    const handleGoogleAuthResponse = (credential)=>{
        setPageState(true)
        if(goodEmails.includes(credential)){
            setAuthSuccesfull(true)
            console.log('Correct User')
            getAllProducts()
        }
        else{
            setAuthSuccesfull(false)
            console.log('Incorrect User')
        }
        

    }


    const styles = StyleSheet.create({
        container: {
            backgroundColor: '#F0EFEC',
            display: "flex",
            flexDirection:'column',
            gap:'1rem',
            padding:'10px',
            margin: "2% 2% 3%",
            borderRadius:'10px',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                gap:'0rem',
                flexDirection:'row',
            }
        },
        firstContainer: {
            width:'100%',
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "left",
            
        },
        googleContainer:{
            width:'100%',
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center",
        },
        loginGoogle:{
            display: authSuccesfull? "none":"flex",
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize:'2rem',
            width: '50%',
            justifyContent: 'center',

        },
        googleLogout:{
            display: authSuccesfull? "flex":"none",
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize:'2rem',
            width: '50%',
            justifyContent: 'center',
            color: '#011a39'
        },
        optionsContainerStyle:{
            display:'flex',
            flexDirection: 'column',
            //backgroundColor:'red',
            justifyContent: 'center',
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize:'2rem',
            gap: "10px",
            alignItems: "center",
        },
        cardContainer:{
            display:'flex',
            flexDirection:'column',
            justifyContent: 'center',
            gap:'5px',
            "@media (min-width: 1024px)": {
                gap:'0rem',
                flexDirection:'row',
            }
        },
        buttonsContainer:{
            display:'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        buttons:{
            fontFamily: "Oswald",
            fontSize:'1.5rem',
            display: "inline-block",
            cursor: "pointer",
            userSelect: "none",
            backgroundColor: '#fec803',
            ":hover": {
                    backgroundColor:'#011a39',
                    color:"white",
                },
            border: "none",
            padding:"0.52rem 4rem",
            margin: "1rem 0px 0.8rem",
            gridColumnStart: "1",
            gridColumnEnd: "4",
            gridRowStart: "3",
            borderRadius:'6px',
            transition:'0.3s'
        },
        generalContainer:{
                backgroundColor: '#F0EFEC',
                display: "flex",
                flexDirection:'column',
                gap:'1rem',
                padding:'10px',
                margin: "2% 2% 3%",
                borderRadius:'10px',
        }

    });
   
    return (
        <>
        <div className={css(styles.container)}>
        <div className={css(styles.googleContainer)}>
            <GoogleLogin 
                className={css(styles.loginGoogle)}
                clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}
                buttonText="Login"
                onSuccess={credentialResponse =>{
                    if (!authSuccesfull){

                        console.log(credentialResponse.profileObj.email)
                        handleGoogleAuthResponse(credentialResponse.profileObj.email)
                    }
                }}
                onFailure={()=>{
                    console.log('error')
                    window.location.href = "/"
                }}
            />
            <GoogleLogout
                className={css(styles.googleLogout)}
                clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}
                buttonText={"Logout"}
                onLogoutSuccess={()=>{
                    console.log("logout")
                    window.location.href = "/"
                }}
            />
        </div>
        </div>
        {
            authSuccesfull?
            <div className={css(styles.optionsContainerStyle)}>{title}</div>:
            <></>
        }
        {
            authSuccesfull?
            <div>
                {
                    pageState?
                        <div className={css(styles.generalContainer)}>
                            {
                                Object.values(productsList).map((prod)=>{
                                    return <div className={css(styles.cardContainer)}>
                                        <ProductItem
                                            key={prod.uid} 
                                            img={prod.mainImage} 
                                            title={prod.title} />
                                        <div className={css(styles.buttonsContainer)}>
                                            <button className={css(styles.buttons)} onClick={()=>{
                                                setTitle(prod.title)
                                                setProductDisplayInfo(
                                                <ProductInfo
                                                mainImage={prod.mainImage}
                                                title={prod.title}
                                                productTpe={prod.productTpe}
                                                description={prod.description}
                                                secondImage={prod.secondImage}
                                                firstMiniTitle={prod.firstMiniTitle}
                                                fisrtMiniDescription={prod.fisrtMiniDescription}
                                                thirdImage={prod.thirdImage}
                                                secondMiniDescription={prod.secondMiniDescription}
                                                secondMiniTitle={prod.secondMiniTitle}
                                                specs={prod.specs}
                                                otherImages={prod.otherImages}
                                                url={prod.url}
                                                uid={prod.uid}
                                                />)
                                            
                                                setPageState(false)
                                            }}>Edit</button>
                                            <button className={css(styles.buttons)} onClick={()=>{
                                                deleteProductFromDB(prod.uid)
                                                alert(prod.title + " Deleted!")
                                            }}>Delete</button>
                                        </div>
                                    </div>
                                })
                            }
                            <button className={css(styles.buttons)} onClick={()=>{
                                setTitle('New')
                                setProductDisplayInfo(
                                    <ProductInfo
                                    mainImage={''}
                                    title={''}
                                    productTpe={''}
                                    description={''}
                                    secondImage={''}
                                    firstMiniTitle={''}
                                    fisrtMiniDescription={''}
                                    thirdImage={''}
                                    secondMiniDescription={''}
                                    secondMiniTitle={''}
                                    specs={''}
                                    otherImages={''}
                                    url={''}
                                    uid={false}
                                    />)

                                setPageState(false)
                            }}>Create New Product</button>
                        </div>:
                        <div className={css(styles.generalContainer)}>
                      
                            {productDisplayInfo}
                            <button 
                                className={css(styles.buttons)} onClick={()=>{

                                    setPageState(true)
                                    setTitle('Products')
                                }
                                }>Back</button>
                        </div>
                }
            </div>:
            <></>
        }
        </>
    );  

}